module.exports = __webpack_public_path__ + "img/404_Banner.f3d217c.png";